/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./App.css";
import { deleteCookie, getCookie, RehydrateThumbnails, setCookie, useInterval } from "./components/Common";

// Material UI
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { MuiTheme, PRICEFILE_KEY } from "./AppConfig";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

// App Components
import TopBar from "./components_main/TopBar";
import Main from "./components_main/Main";
import Designer from "./components_designer/Designer";
import { ClosePaper } from "./components_designer/layout/PaperFunctions";
import LogInDialog from "./components_main/LogInDialog";
import ErrorIcon from "@material-ui/icons/Error";
import DragDrop from "./components_main/DragDrop";

// Redux Actions
import {
    MAIN_PAGE,
    DESIGNER_PAGE,
    UPDATE_PAGE,
    changePage,
    changeMainPage,
    checkInternetConnection,
    SetAppDialogMessage,
    saveUserToWeb,
    UPDATE_APP,
    updateAPP,
} from "./redux_store/appState";
import { NEW_JOB, loadJob } from "./redux_store/jobState";
import { Backdrop, Button, CircularProgress, Dialog, Typography } from "@material-ui/core";
import Announcements from "./components_main/Announcements";
import {
    updateDesigner,
    resetDesigner,
    SHOW_LOADING_BACKDROP,
    setDesignerLoadingBackdrop,
} from "./redux_store/appState";
import Dash from "./admin/Dash";
import ErrorBoundary from "./ErrorBoundary";
import BSL_Dialog from "./components/BSL_Dialog";
import BSL_LoadingButton from "./components/BSL_LoadingButton";
import Augmented from "./augmented_reality/Augmented";
import { LogOut } from "./components_main/ManageUser";
import TermsConditions, { TermsModalContent, updateRenewDate } from "./components/TermsConditions";
import { mergedState } from "./redux_store";
import { decryptData, getStoreDatabase } from "./redux_store/database";
import { bomPassTest, canLoadJobs } from "./admin/DebugTools";
import { deckEngineering_test } from "./components_designer/specification_drawer/decks/DeckEngineering";

// Material UI
const theme = createTheme(MuiTheme({ FIELDERS: window.F }));
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

export default function App(props) {
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const offerings = useSelector((state) => state.app.offerings);
    const dispatch = useDispatch();

    const { page, user, logged_user_code, online } = app;

    const user_status = user?.Status;
    const business_status = user?.BusinessDetails?.Status;
    const business_name = user?.BusinessDetails?.Name;

    const [setPopEvent, setSetPopEvent] = React.useState(false);
    const [jobToLoad, setJobToLoad] = React.useState("");
    const [loadingDefaultJob, setLoadingDefaultJob] = React.useState(false);
    const [dateLoaded, setDateLoaded] = React.useState(null);
    const [licenseOpen, setLicenseOpen] = React.useState(false);
    const [loadingUser, setLoadingUser] = React.useState(false);
    const [allowAccept, setAllowAccept] = React.useState(false);
    const [loadedDefaultState, setLoadedDefaultState] = React.useState(false);
    const [bomTestResult, setBomTestResult] = React.useState("STARTING UP");
    
    const [warningMessages, setWarningMessages] = React.useState([]);

    useEffect(() => {
        const getPriceFileData = async () => {
            let encryptedPricefile = null;

            try {
                encryptedPricefile = JSON.parse(await getStoreDatabase());
            } catch {
                encryptedPricefile = null;
            }

            // Decrypt the encrypted data
            let pricefile_data_session;

            if (encryptedPricefile?.data && encryptedPricefile?.iv)
                pricefile_data_session = decryptData(
                    encryptedPricefile.data, // Access the "data" property that contains the encrypted data
                    encryptedPricefile.iv,
                    PRICEFILE_KEY // Encyrption Key
                );

            if (pricefile_data_session)
                dispatch(updateAPP("pricefile", RehydrateThumbnails(JSON.parse(pricefile_data_session))));
        };
        getPriceFileData();
    }, []);

    useEffect(() => {
        if (window.location.href.includes("bom-auto-test") && user?.Role === 99) {
            if (bomTestResult === "STARTING UP") {
                setBomTestResult("LOADING ...");

                bomPassTest({ app, user }).then((testResult) => {
                    const resultElement = testResult ? "PASSED" : "FAILED";
                    setBomTestResult(resultElement);
                });
            }
        }
        if (window.location.href.includes("load-bom-auto-test") && user?.Role === 99) {
            if (bomTestResult === "STARTING UP") {
                setBomTestResult("LOADING ...");

                bomPassTest({ app, user }).then((testResult) => {
                    const resultElement = testResult ? "PASSED" : "FAILED";
                    setBomTestResult(resultElement);
                });
            }
        }
    }, [user, app]);

    let agreement = user?.license_agreement;

    // TermsConditions UseEffect
    TermsConditions({
        logged_user_code,
        user,
        agreement,
        config,
        dispatch,
        saveUserToWeb,
        setLicenseOpen,
    });

    useInterval(() => {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let hrs = today.getHours();
        let mins = today.getMinutes();
        let yyyy = today.getFullYear();
        today = mins + mm + "/" + dd + "/" + yyyy;

        if (!dateLoaded) {
            setDateLoaded(today);
        } else if (dateLoaded !== today && hrs > 2) {
            window.location.reload(true);
            return;
        }
        //
    }, 60 * 60 * 1000);

    useInterval(() => {
        if (window.debug && window.location.href.includes("use_cache") && getCookie("CDS_token")) return;
        if (!online && !document.hidden) {
            //
            checkInternetConnection(dispatch);
        }
    }, 3000);

    useEffect(() => {
        if (page === DESIGNER_PAGE) {
            document.documentElement.style.overflow = "hidden";
            document.documentElement.style.scrollbarGutter = "unset";
        }

        if (page === MAIN_PAGE) {
            document.documentElement.style.overflow = "auto";
            document.documentElement.style.scrollbarGutter = "stable";
            ClosePaper();
            dispatch({
                type: NEW_JOB,
                parameter: null,
            });
        }
    }, [page]);

    useEffect(() => {
        if (!setPopEvent) {
            window.onpopstate = function (event) {
                if (event?.state?.MAIN_PAGE?.page) {
                    dispatch(changeMainPage(event?.state?.MAIN_PAGE?.page, false));
                } else {
                    dispatch({
                        type: UPDATE_PAGE,
                        value: MAIN_PAGE,
                    });
                    dispatch(changeMainPage("Recall", false));
                }
            };
            setSetPopEvent(true);
        }
    }, [setPopEvent]);

    const loadDefaultJob = (jobid) => {
        const business_code = user?.BusinessDetails?.Code;
        dispatch(changePage(DESIGNER_PAGE));
        dispatch(setDesignerLoadingBackdrop("Loading #" + jobid));
        dispatch(loadJob(business_code, jobid, user)).then((result) => {
            // setLoadingDefaultJob(false);
            if (!result) {
                dispatch(loadJob(business_code, jobid, user)).then((result) => {
                    // setLoadingDefaultJob(false);
                    if (!result) {
                        dispatch(
                            setDesignerLoadingBackdrop(
                                <div onClick={() => loadDefaultJob(jobid)}>
                                    <ErrorIcon style={{ fontSize: 40, color: "#ffa8a8" }} />
                                    <br />
                                    <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                                        <span>Error Loading # {jobid} ... try again?</span>
                                    </Typography>
                                </div>
                            )
                        );
                    } else {
                        dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
                        dispatch(resetDesigner());
                    }
                });
            } else {
                dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
                dispatch(resetDesigner());
            }
        });
    };

    const handlePageChange = (force = false) => {
        const url = window.location.href;
        //

        if (url.includes("job=") && (!loadingDefaultJob || force)) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const job_id = urlParams.get("job");

            setJobToLoad(job_id);

            if (logged_user_code && user && (page === null || page === MAIN_PAGE)) {
                dispatch(changePage(DESIGNER_PAGE));
                dispatch(setDesignerLoadingBackdrop("Loading #" + job_id));
            }

            if (url.includes("static")) {
                dispatch({
                    type: UPDATE_APP,
                    parameter: "logged_user_code",
                    value: "kevinchan@qikdraw.com.au.lld.bbccomms",
                });

                setLoadingDefaultJob(true);

                loadDefaultJob(job_id);
                setJobToLoad(null);
            }
        }

        if (!loadedDefaultState) {
            //

            setLoadedDefaultState(true);
            mergedState({}).then((result) => {
                //
                dispatch({
                    type: "SET_STATE",
                    value: result,
                });
            });
        }
    };

    useEffect(() => {
        if (jobToLoad && !loadingDefaultJob) {
            if (logged_user_code && user && !job && offerings) {
                setLoadingDefaultJob(true);

                loadDefaultJob(jobToLoad);
                setJobToLoad(null);
            }
        }
    }, [user, offerings, logged_user_code]);

    // Load the page designer
    useEffect(() => {
        handlePageChange();
    }, []);

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - 20 <= e.target.clientHeight;
        if (bottom) {
            setAllowAccept(true);
        }
    };

    const url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    if (url.includes("?dash") && user?.Role === 99) {
        return (
            <ErrorBoundary>
                <MuiThemeProvider theme={theme}>
                    <Dash />
                </MuiThemeProvider>
            </ErrorBoundary>
        );
    }

    // Beta
    if (url.includes("init-beta")) {
        // Set token
        const token = params.get("CTK");
        const userName = params.get("SFU");

        // Set the token as a cookie named CDS_token
        document.cookie = `CDS_token=${token}; path=/; secure`;
        document.cookie = `SF_user=${userName}; path=/; secure`;
    }

    // Augmented Reality
    if (window.location.href.includes("3d-viewer")) {
        return <Augmented />;
    }

    if (window.location.href.includes("bom-auto-test") && user?.Role === 99) {
        return <h3 style={{ fontWeight: "bold", padding: 20 }}>{bomTestResult}</h3>;
    }

    if (
        (user?.id.includes("kevinchan") || user?.id.includes("michael.abdo")) &&
        window.debug &&
        window.location.href.includes("?dev")
    ) {
        deckEngineering_test();
    }

    if (licenseOpen && !((page === null || page === MAIN_PAGE) && user)) {
        // redirect user back to home page to stop user from bypassing using HTML.
        dispatch(changePage(MAIN_PAGE));
    }

    let CDS_token_id = getCookie("CDS_token_id");

    // Check if CDS_token_id needs to be updated
    if (
        CDS_token_id &&
        CDS_token_id !== "" &&
        CDS_token_id !== String(config?.CDS_token_id) &&
        config?.CDS_token_id &&
        getCookie("CDS_token")
    ) {
        deleteCookie("CDS_token");
        deleteCookie("SF_user");
        setCookie("CDS_token_id", config.CDS_token_id);
        window.location.reload(true);
    }

    // Handle the case where CDS_token_id is an empty string and update the cookie
    if (CDS_token_id === "" && config?.CDS_token_id) {
        setCookie("CDS_token_id", config.CDS_token_id);
    }

    return (
        <ErrorBoundary>
            <MuiThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div className={"App"} style={{ background: window.LYSAGHT ? "#F2F2F0" : "auto" }}>
                        {/* <CheckPersistedStateDialog check={((page === null || page === MAIN_PAGE) && user)}/> */}
                        {/* {((page === null || page === MAIN_PAGE) && user) && */}
                        <TopBar page={page} />
                        <Announcements  warningMessages={warningMessages} />
                        {/* } */}
                        {!online && (
                            <Backdrop
                                style={{
                                    zIndex: 10100,
                                    color: "#fff",
                                }}
                                open={!online}
                            >
                                <CircularProgress color="inherit" style={{ position: "absolute" }} />
                                <br />
                                <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                                    {window.tokenexpired > 0
                                        ? "Cannot contact server... login token may be expired..."
                                        : "Cannot contact server... waiting for connection..."}
                                </Typography>
                            </Backdrop>
                        )}
                        {offerings &&
                            business_status &&
                            business_status !== "ACTIVE" &&
                            user_status &&
                            user_status === "ACTIVE" && (
                                <Backdrop
                                    style={{
                                        zIndex: 10100,
                                        color: "#fff",
                                    }}
                                    open={true}
                                >
                                    {/* <CircularProgress color="inherit" style={{ position: "absolute" }} /> */}
                                    {/* <br /> */}
                                    <Typography variant="overline" gutterBottom>
                                        Business Details for
                                        <br />
                                        <span style={{ fontSize: "24px" }}>{business_name}</span>
                                        <br />
                                        need to be set up.
                                        <br />
                                        Please contact your Sales Rep to Complete Setup.
                                    </Typography>
                                </Backdrop>
                            )}
                        {offerings &&
                            (user_status !== "ACTIVE" || !user_status) &&
                            !window.location.href.includes("static") && (
                                <Backdrop
                                    style={{
                                        zIndex: 9999,
                                        color: "#fff",
                                    }}
                                    open={true}
                                >
                                    {/* <CircularProgress color="inherit" style={{ position: "absolute" }} /> */}
                                    {/* <br /> */}
                                    <Typography variant="overline" gutterBottom>
                                        Your User Profile
                                        <br />
                                        <span style={{ fontSize: "24px" }}>{user?.DisplayName}</span>
                                        <br />
                                        is not active.
                                        <br />
                                        Please contact your Sales Rep to Setup.
                                    </Typography>
                                </Backdrop>
                            )}

                        {!logged_user_code && online && !window.location.href.includes("static") && (
                            <LogInDialog config={config} />
                        )}

                        {/* {!logged_user_code && online && window.location.href.includes("beta") && <LoadingStep />} */}

                        {!window.location.href.includes("static") && !jobToLoad && (
                            <Main visible={(page === null || page === MAIN_PAGE) && user} />
                        )}
                        {page === DESIGNER_PAGE && logged_user_code && <Designer  warningMessages={warningMessages} setWarningMessages={setWarningMessages}  />}
                        {page !== DESIGNER_PAGE && logged_user_code && window.FIELDERS && <DragDrop />}

                        <BSL_Dialog
                            open={app?.MAIN_PAGE?.Message}
                            onClose={() => {
                                dispatch(SetAppDialogMessage(""));
                            }}
                            button1Text="Close"
                            button1Click={() => {
                                dispatch(SetAppDialogMessage(""));
                            }}
                        >
                            {app?.MAIN_PAGE?.Message}
                        </BSL_Dialog>
                    </div>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
            <Dialog open={licenseOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div style={{ padding: "20px" }}>
                    <h2>License Agreement</h2>
                    <p>In order to continue please accept the License Agreement Below.</p>
                    <div onScroll={handleScroll} style={{ height: "450px", overflowY: "scroll" }}>
                        <TermsModalContent />
                    </div>
                </div>
                <div style={{ margin: "0px 20px" }}>
                    <p style={{ margin: "0px" }}>
                        User may be required to accept the terms and any updated terms on annual basis
                    </p>
                </div>
                <div style={{ justifyContent: "space-between", display: "flex", margin: "10px" }}>
                    <Button
                        style={{ color: "#8d8d8d", font: "400 14px 'canada-type-gibson', sans-serif" }}
                        onClick={(e) => {
                            LogOut({ dispatch });
                        }}
                    >
                        Reject and Logout
                    </Button>
                    <BSL_LoadingButton
                        style={{ width: "80px" }}
                        disabled={!allowAccept}
                        loading={loadingUser}
                        // finished={finishedLoading}
                        onClick={(e) => {
                            setLoadingUser("true");
                            updateRenewDate({
                                agreement,
                                config,
                                user,
                                dispatch,
                                saveUserToWeb,
                                addHistory: true,
                            }).then((e) => {
                                setLicenseOpen(false);
                                setLoadingUser(false);
                                handlePageChange({ force: true });
                            });
                        }}
                    >
                        Accept
                    </BSL_LoadingButton>
                </div>
            </Dialog>

            {window.LYSAGHT &&
                window.Intercom("update", {
                    app_id: "nxhqnktw",
                    email: app?.user?.Email,
                    name: app?.user?.DisplayName,
                    user_id: app?.user?.id,
                    phone: app?.user?.BusinessDetails?.Phone,
                    //created_at: new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }),
                    company: {
                        company_id: app?.user?.BusinessCode,
                    },
                })}
        </ErrorBoundary>
    );
    // }
}
